export default __webpack_public_path__ + "static/media/1_3_logo.233df40e.png";